import { getStore } from '../store/store';

export default function getBulkActionProgress(folderId: string): {
    processedCount: number;
    totalCount: number;
    percentComplete: number;
} | null {
    const bulkActionInfo = getStore().bulkActionInformationMap.get(folderId);
    return bulkActionInfo ? bulkActionInfo.progress : null;
}
